import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { LMHomePageUtilService } from './lm-home-page-util.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { SubscriptionLike as ISubscription } from 'rxjs';

@Component({
  selector: 'lm-home-page',
  template: `<div></div>`,
  providers: [LMHomePageUtilService]
})
export class LMHomePageComponent implements AfterViewInit {

  private routerEventSubscription: ISubscription;

  constructor(
    private router: Router,
    private lmHomePageUtilService: LMHomePageUtilService,
    private lmUrlUtilService: LMUrlUtilService
  )  {}

  ngAfterViewInit() {
    this.loadHomePageRedirect(this.router.url);
  }

  // todo combine all "getRedirectUrl" functions into a single service.
  loadHomePageRedirect(url: string) {
    // append output=spec so we can retreive the redirect url in a json format.
    const delimiter = (url.indexOf('?') ===  -1) ? '?' : '&';
    url += delimiter + 'output=spec';

    this.lmHomePageUtilService.getHomePageRedirect(url).subscribe(
      response => {
        // router requires a relative url, FQDN url doesn't work with navigateByUrl
        const relativeUrl = this.lmUrlUtilService.toRelativeUrl(response.redirectUrl);
        this.router.navigateByUrl(relativeUrl,  { replaceUrl: true });
      },
      error => {
        // handle error
      });
  }

  checkSaveRequired() {
    return false;
  }

  public allowPageNavigation(): Promise<boolean> | boolean {
    return true;
  }
}
